<template>
  <div class="register">
    <div class="title">重置密码</div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="register_form"
    >
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="ruleForm.email" placeholder="请输入账户绑定邮箱"></el-input>
      </el-form-item>
      <el-form-item label="验证码" class="verifyCode" prop="captcha">
        <el-input v-model="ruleForm.captcha" placeholder="请输入验证码"></el-input>
        <el-button
          @click="sendMessaheCode()"
          :disabled="disabled"
          :class="disabled?'disabled':''"
        >{{timer.message}}</el-button>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="ruleForm.password" type="password" placeholder="请输入密码"></el-input>
        <div class="tips">注:密码不少于8位，且包含大小写字母数字</div>
      </el-form-item>
      <el-form-item label="确认密码" prop="repassword">
        <el-input v-model="ruleForm.repassword" type="password" placeholder="请再次输入密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="submitBtn" @click="forget">重置密码</el-button>
        <el-button @click="goback" icon="el-icon-refresh-left">返回登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { sendMessaheCode, forget, sendEmail } from '@/libs/api'
export default {
  data() {
    var emailCheck = (rule, value, callback) => {
      var strRegex = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if (value == '') {
        callback(new Error('邮箱不得为空'))
      } else if (!strRegex.test(value)) {
        callback(new Error('邮箱格式不正确'))
      } else {
        callback()
      }
    };
    var repasswordCheck = (rule, value, callback) => {
      if (value != this.ruleForm.password || value == '') {
        callback(new Error('两次填入的密码需要保持一致'))
      } else {
        callback()
      }
    };
    return {
      disabled: false,
      timer: {
        time: 60,
        message: '获取验证码',
        value: ''
      },
      ruleForm: {
        email: '',
        password: '',
        repassword: '',
        captcha: '',
      },
      rules: {
        email: [
          { required: true, validator: emailCheck, trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 5, message: '长度不能低于5位字符', trigger: 'blur' }
        ],
        repassword: [
          { required: true, validator: repasswordCheck, trigger: 'blur' }
        ]
      },
      captchaId: ''
    };
  },
  components: {
  },
  watch: {
  },
  methods: {
    sendMessaheCode: function () {
      var strRegex = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if (strRegex.test(this.ruleForm.email)) {
        sendEmail({ type: 2, email: this.ruleForm.email }).then(res => {
          this.captchaId = res.data;
          if (res.status) {
            this.$message({
              message: '邮件发送成功',
              type: 'success'
            });
            //禁止点击按钮
            this.disabled = true
            //定时器定时读秒
            this.timer.value = setInterval(() => {
              this.timer.time--;
              this.timer.message = ('还剩' + this.timer.time + '秒')
              if (this.timer.time == 0) {
                //关闭定时器，启用按钮
                window.clearInterval(this.timer.value)
                this.timer.message = '获取验证码'
                this.disabled = false
                this.timer.time = 60
              }
            }, 1000)
          } else {
            this.$alert(res.message, '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
        })
      } else {
        this.$alert('邮箱格式不正确', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }
    },
    forget: function () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          forget(this.ruleForm, { captchaId: this.captchaId, captchaText: this.ruleForm.captcha }).then(res => {
            if (res.status) {
              this.$alert('密码找回成功，快去登录吧！', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$router.push({ name: 'login' })
                }
              });
            } else {
              this.$alert('密码找回失败，请稍后尝试！' + res.message, '错误', {
                confirmButtonText: '确定',
                callback: action => {
                }
              })
            }
          });
        }
      })
    },
    resetForm: function () {
      this.$refs['ruleForm'].resetFields();
    },
    goback: function () {
      this.$router.go(-1);
    }
  }
}
</script>
<style scoped lang='less'>
.register {
  margin: 0 auto;
  margin-top: 6vh;
  width: 30%;
  background-color: white;
  border-radius: 5px;
  box-sizing: border-box;
  background-image: url('~@/assets/images/registerbg.jpg');
  background-repeat: no-repeat;
  background-position: bottom;
  background-color: #f1eee7;
  .title {
    font-size: 20px;
    height: 6vh;
    display: flex;
    align-items: center;
    padding-left: 2%;
    border-bottom: 1px solid #ccc;
    width: 95%;
    margin: 0 auto;
    box-sizing: border-box;
  }
}
</style>
<style lang="less">
.register_form {
  width: 93%;
  padding-top: 3vh;
  padding-bottom: 1.5vh;
  .verifyCode {
    .el-form-item__content {
      display: flex;
      justify-content: space-between;
    }
    .disabled {
      background-color: #ccc;
    }
    .el-input {
      width: 73%;
    }
    .el-button {
      display: inline-block;
      background-color: #ae0c2a;
      color: white;
    }
  }
  .el-select {
    width: 100%;
  }
  .submitBtn {
    background-color: #ae0c2a;
    border: none;
  }
  .tips {
    font-size: 12px;
    height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/single/forget.vue